// 导入配置好的axios实例
import axios from './axiosInstance';

// 提交留言
export const submitMessage = (data) => {
  return axios.post('/messages', data)
    .then(response => response.data)
    .catch(error => {
      console.error('提交留言API调用失败:', error);
      throw error;
    });
};

export const getMessages = () => {
  return axios.get('/messages')
    .then(response => response.data)
    .catch(error => {
      console.error('获取留言列表API调用失败:', error);
      throw error;
    });
};

// 标记留言为已读
export const markMessageAsRead = (messageId) => {
  return axios.put(`/messages/${messageId}/read`);
};

// 删除留言
export const deleteMessage = (messageId) => {
  return axios.delete(`/messages/${messageId}`);
};